// Cliente de POST /api/upload (celular). Usa XMLHttpRequest — não fetch — porque só
// o XHR expõe progresso de upload (upload.onprogress); o médico numa rede de UBS ruim
// precisa ver que o envio não travou. O corpo é o áudio bruto (Blob), como o servidor
// espera (upload.ts lê request.body como Buffer, sem multipart).

export type ResultadoEnvio =
  | { ok: true; pairingCode: string }
  | { ok: false; motivo: string };

export function enviarAudio(
  blob: Blob,
  onProgresso?: (enviados: number, total: number) => void,
): Promise<ResultadoEnvio> {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/upload');
    // blob.type é ex. "audio/webm;codecs=opus" (Android) ou "audio/mp4" (iOS). O
    // servidor faz split(';')[0], então o codec não atrapalha.
    xhr.setRequestHeader('Content-Type', blob.type || 'application/octet-stream');

    xhr.upload.onprogress = (e) => {
      if (onProgresso) onProgresso(e.loaded, e.lengthComputable ? e.total : 0);
    };
    xhr.onload = () => {
      if (xhr.status === 201) {
        try {
          const body = JSON.parse(xhr.responseText) as { pairingCode: string };
          resolve({ ok: true, pairingCode: body.pairingCode });
        } catch {
          resolve({ ok: false, motivo: 'Resposta inválida do servidor.' });
        }
      } else if (xhr.status === 400) {
        resolve({ ok: false, motivo: 'O servidor recusou o áudio (formato ou corpo vazio).' });
      } else {
        resolve({ ok: false, motivo: `Falha no envio (HTTP ${xhr.status}).` });
      }
    };
    xhr.onerror = () =>
      resolve({ ok: false, motivo: 'Sem conexão com o servidor. Verifique a rede e tente de novo.' });
    xhr.ontimeout = () => resolve({ ok: false, motivo: 'O envio demorou demais. Tente de novo.' });

    xhr.send(blob);
  });
}
